import m from "../../geodata/es2015/hungaryHigh";
window.am4geodata_hungaryHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/hungaryHigh.js
// module id = null
// module chunks = 